<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <btn :class="['mr-2']" :disabled="level === 1" @click="brightness(false)" size="xs" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.decreaseBrightness" :bg-color-lightness="$root.$colors.bgColorLightness" icon-left="minus" /><!--
          --><btn :disabled="level === 7" @click="brightness" size="xs" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.increaseBrightness" :bg-color-lightness="$root.$colors.bgColorLightness" icon-left="plus" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.visible" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="visible" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <visual-feedback-icon :name="`brightness-${level}`" :visible="visible" :class="['p-12', 'pb-6']">
          <container v-html="`${$lang.brightness}: ${level}`" :class="['font-semibold', 'pt-4', 'text-gray-500', 'uppercase']" />
        </visual-feedback-icon>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageVisualFeedbackIcon',
  data () {
    return {
      visible: true,
      level: 1
    }
  },
  methods: {
    brightness (up = true) {
      up ? this.level++ : this.level--
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/visual-feedback-icon.vue